module.exports = __webpack_public_path__ + "static/media/globe.842db1bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Team/AboutBox/img/globe.svg
// module id = 292
// module chunks = 0